<template>
    <div>
      <v-card>
        <v-card-text>
          <v-row>
                <h2>Family Member Export</h2>
            </v-row>
          <!-- <v-row>
            <v-col lg="6">
              <label>Township Group</label>
            <v-select
              v-model="township_group_id"
              outlined
              dense
              item-text="name"
              item-value="id"
              :items="townshipGroups"
            ></v-select>
            </v-col>
            <v-col lg="6">
                <v-card-actions>
                    <v-btn class="form-btn" @click="exportData">
                        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
                    </v-btn>
                </v-card-actions>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col lg="4">
                  <label>Enroll Nominated Month</label>
                  <v-select
                    class="mr-1"
                    :items="s_export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="monthValidation"
                    item-value="value"
                    dense
                    outlined 
                  ></v-select>
                </v-col>
                <v-col  lg="4">
                  <label>Enroll Nominated Year</label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="yearValidation"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <!-- <v-col  lg="3">
                  <label>Diagnoses</label>
                  <v-select
                    class="mr-1"
                    :items="[{value:1,text:`No`},{value:2,text:`Yes`}]"
                    v-model="diagnoses"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col> -->
            <v-col lg="4">
                <v-card-actions>
                    <v-btn class="form-btn" @click="exportData"  :loading="loading">
                        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
                    </v-btn>
                </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    components: {},
    data: () => ({
      loading:null,
      // township_id: null,
      month:null,
      year:null,
      diagnoses:1,
    }),
    
    computed: {
      ...mapState("Loading", ["loading"]),
      ...mapState("Township", ["townships"]),
      ...mapState("TownshipGroup", ["townshipGroups"]),
      ...mapState("InitialData", ["s_export_months", "years"]),
    },
    methods: {
      exportData() {
        let data = {
          month:this.month,
          year:this.year,
          diagnoses:this.diagnoses,
        };

        if (this.month && this.year && this.diagnoses) {
          console.log( this.loading);
          this.loading=true;
          this.$store.dispatch("Presumptive/familymembergetExport", data) .then(() => (
            this.loading=false));
        }else
        {   data.diagnoses=null;
            data.month=null;
            data.year=null;
             alert('Please fill all options');
             return false;
        }

        
      },
    },
    created() {
    //   this.$store.dispatch("Township/getTownships");
      this.$store.dispatch("TownshipGroup/getTownshipGroups");
    },
  };
  </script>
  
  <style scoped></style>
  